import React, { useState } from "react";
import styles from "../Available_Links/Available_Links.module.css";
import serving_Data from "../../Data/RO-landing.json";

const Available_Links = () => {
  const [limit, setLimit] = useState(9);
  let api_data = serving_Data[0].internalLinks.alsoAvailableIn;

  return (
    <div className={styles.container}>
      <div className={styles.heading}> Also available in</div>
      <div className={styles.inner}>
        {api_data.slice(0, limit).map((name, index) => {
          return (
            <div className={styles.list}>
              <a href={name.link} target={"_blank"}>
                *{name.anchorText}
              </a>
            </div>
          );
        })}
        <button onClick={() => setLimit(limit + 3)}>More......</button>
      </div>
    </div>
  );
};

export default Available_Links;
